import { getMyRoles, isSuperAdmin } from "api/Auth/useAuth";
import { notification } from "constants/notification";
import i18n from "i18n";
import MainStore from "MainStore";
import { makeAutoObservable, runInAction } from "mobx";
import ReleaseApproveSectionStore from './Header/ReleaseApproveSection/store'
import {clearNotification, clearNotifications, getmynotifications} from "../../api/notification";

interface EmployeeResponse {
  last_name: string;
  first_name: string;
}

class NewStore {
  drawerOpened = false;
  notifications: notification[] = [];
  curentUserName = '';
  last_name = '';
  employee_id = 0;
  user_id = 0;
  first_name = '';
  head_of_structures = [];
  my_structures = [];
  post_ids = [];
  openPanel = false;
  open = false; // Menu open state
  selectedIndex = 0; // Index of the selected list item
  isSuperAdmin: boolean = false;
    fullname = "";
    organization = "";
    isAdmin: boolean = false;
    organization_id = 0;

  constructor() {
    makeAutoObservable(this);
  }

  clearStore() {
    runInAction(() => {
      this.notifications = [];
      // Reset or clear other state as needed
    });
  }

    async getNotifications() {
    // Проверяем авторизацию перед запросом
    const token = localStorage.getItem('token') || localStorage.getItem('currentUser');
    
    if (!token) {
      console.log('User not authenticated, skipping notification fetch');
      return;
    }

        try {
            const response = await getmynotifications();
            if ((response.status === 201 || response.status === 200) && response?.data !== null) {
                runInAction(() => {
                    this.notifications = response.data;
                });
            } else {
                throw new Error('Failed to load notifications');
            }
        } catch (err) {
      // Проверяем, что пользователь все еще авторизован перед показом ошибки
      const currentToken = localStorage.getItem('token') || localStorage.getItem('currentUser');
      
      if (currentToken) {
            console.error('Error fetching notifications:', err);
            MainStore.setSnackbar(i18n.t('message:cannotLoadNotifications'), 'error');
      } else {
        // Пользователь вышел из системы, просто логируем
        console.log('Notification fetch failed - user logged out');
        }
    }
  }

    async clearAllNotifies() {
        const currentUser = localStorage.getItem('currentUser');
        try {
            if (!currentUser) throw new Error('No current user found');
            MainStore.changeLoader(true);
            const response = await clearNotifications(currentUser);
            console.log('clearAllNotifies response:', response);
            if ((response.status === 201 || response.status === 200) && response?.data !== null) {
                await this.getNotifications(); // Refresh notifications after clearing
            } else {
                throw new Error('Failed to clear notifications');
            }
        } catch (err) {
            console.error('Error clearing notifications:', err);
            MainStore.setSnackbar(i18n.t('message:somethingWentWrong'), 'error');
        } finally {
            MainStore.changeLoader(false);
        }
    }

    async clearNotify(id: number) {
        try {
            MainStore.changeLoader(true);
            const response = await clearNotification(id);
            console.log('clearNotify response:', response);
            if ((response.status === 201 || response.status === 200) && response?.data !== null) {
                await this.getNotifications(); // Refresh notifications after clearing
            } else {
                throw new Error('Failed to clear notification');
            }
        } catch (err) {
            console.error('Error clearing notification:', err);
            MainStore.setSnackbar(i18n.t('message:somethingWentWrong'), 'error');
        } finally {
            MainStore.changeLoader(false);
        }
    }

  async checkIsSuperAdmin() {
    const currentUser = localStorage.getItem("currentUser");
    try {
      const response = await isSuperAdmin(currentUser);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        this.isSuperAdmin = response.data;
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:cannotLoadNotifications"), "error");
    }
  }

  // Method to toggle the menu open state
  setOpen(isOpen: boolean) {
    this.open = isOpen;
  }

  // Method to set the selected index
  setSelectedIndex(index: number) {
    this.selectedIndex = index;
  }

  // Method to toggle the drawer state
  changeDrawer() {
    this.drawerOpened = !this.drawerOpened;
  }
}

export default new NewStore();